import { Button, Modal } from "react-bootstrap";
import "./error-message.modal.scss";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { CircularProgress } from "@mui/material";
import { faClose, faWarning } from "@fortawesome/free-solid-svg-icons";
interface ErrorProps {
    isOpen: boolean
    message: string
    onClose(): void
}

const ErrorModal: React.FC<ErrorProps> = ({ isOpen, onClose, message }) => {
   

  
    return (
        <>
            <Modal show={isOpen} onHide={onClose} backdrop="static" centered>

                <Modal.Body>
                    <div className="error-control">
                    <FontAwesomeIcon icon={faClose} onClick={onClose} className="close-icon" />
                        <div className="error-content">
                            

                            <FontAwesomeIcon icon={faWarning} className="error-icon" />
                            <div className="error-loading-control">
                                <span className="error-loading-text">{message}</span>

                            </div>

                        </div>


                    </div>
                </Modal.Body>

            </Modal>
        </>
    )
}

export default ErrorModal;